import { Warning } from "@/assets/icons/ds";

export const ErrorMessage = ({
  name,
  message,
}: {
  name: string;
  message?: string;
}) => {
  return message ? (
    <p
      data-testid={`${name}-alert`}
      role="alert"
      className="mt-2 flex items-center gap-2 text-xs text-foreground-error"
    >
      <Warning className="h-4 w-4 shrink-0" />
      {message}
    </p>
  ) : null;
};
